import { Box } from "@mui/material";

export type TypeInfoIconProps = {
  icon: React.ReactNode;
};

export function TypeInfoIcon({ icon }: TypeInfoIconProps) {
  return <Box sx={{ marginRight: "4px" }}>{icon}</Box>;
}
